<template>
  <div>
    <div class="px-5">
      <ValidationObserver ref="observer">
        <div class="mt-4">ห้าง</div>
        <div>
          <ValidationProvider
            :rules="{
              required: true,
            }"
            name="ห้าง"
            v-slot="{ errors }"
          >
            <v-autocomplete
              :error-messages="errors"
              v-model="input.departmentStore"
              :items="departmentOptions"
              dense
              @change="onChangeDepartment"
              outlined
              placeholder="เลือกห้าง"
            ></v-autocomplete>
          </ValidationProvider>
        </div>

        <div>
          <ValidationProvider
            :rules="{
              required: true,
            }"
            name="เลขที่ใบเสร็จ"
            v-slot="{ errors }"
          >
            <div class="mt-0">เลขที่ใบเสร็จ</div>

            <custom-input
              v-model="input.refNo"
              dense
              outlined
              :error-messages="errors"
            ></custom-input>
          </ValidationProvider>
        </div>
        <div class="mt-0">
          <div class="mb-2">
            แนบใบเสร็จ
            <span
              v-if="receipt_template"
              @click="showExample = true"
              style="float: right"
              class="primary--text text-decoration-underline"
              >ตัวอย่างใบเสร็จ</span
            >
          </div>
          <ValidationProvider
            :rules="{
              required: true,
            }"
            name="รูปใบเสร็จ"
            v-slot="{ errors }"
          >
            <UploadDocument
              :errors="errors"
              :key="keyupload"
              :multiple="!isAndroid"
              v-model="input.refNoImage"
              :max="5"
            >
            </UploadDocument>
            <span v-if="errors.length" class="red--text">กรุณาแนบรูปใบเสร็จ</span>
          </ValidationProvider>
          <div class="red--text">*กรุณาแนบใบเสร็จภายใน 7 วันหลังจากที่ซื้อ</div>
          <div class="red--text">
            *อัพโหลดบิล 1 เลขที่ใบเสร็จต่อ 1 ครั้งเท่านั้น
          </div>
        </div>
        <!-- <div class="mt-0">สาขา</div>
        <div>
          <ValidationProvider
            :rules="{
              required: true,
            }"
            name="สาขา"
            v-slot="{ errors }"
          >
            <v-select
              :error-messages="errors"
              :disabled="$store.state.branchloading"
              :loading="$store.state.branchloading"
              :no-data-text="'กรุณาเลือกห้างก่อนเลือกสาขา'"
              v-model="input.branch"
              :items="branchOptions"
              dense
              outlined
              placeholder="เลือกสาขา"
            ></v-select>
          </ValidationProvider>
        </div> -->
      </ValidationObserver>
      <div>
        <v-btn
          @click="submitData"
          :loading="saveloading"
          style="font-size: 22px"
          class="mt-4 text-capitalize"
          color="primary"
          dark
          block
        >
          <span> {{ edittype === "edit" ? "บันทึก" : "อัพโหลดใบเสร็จ" }}</span>
        </v-btn>
      </div>
    </div>
    <v-dialog width="550px" v-model="showExample" persistent>
      <v-card>
        <div class="text-right">
          <v-btn @click="showExample = false" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-img v-if="receipt_template" :src="receipt_template"></v-img>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showCollectSuccess" width="500px" persistent>
      <v-card v-if="showCollectSuccess">
        <CollectSuccess :edittype="edittype" @close="showCollectSuccess = false"></CollectSuccess>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UploadDocument from "@/components/UploadMultipleFile.vue";
import axios from "axios";
import CollectSuccess from "./CollectSuccess.vue";
export default {
  props: ["edittype", "editdata"],
  components: {
    UploadDocument,
    CollectSuccess,
  },
  data() {
    return {
      showCollectSuccess: false,
      receipt_templateloading: false,
      receipt_template: "",
      showExample: false,
      saveloading: false,
      keyupload: 0,
      branchOptions: [],
      input: {
        departmentStore: "",
        branch: "",
        refNoImage: [],
        refNo: "",
      },
      isAndroid: false,
    };
  },
  computed: {
    departmentOptions() {
      var departments = [...new Set(this.$store.state.branch.map((el) => el.department_store))];
      return departments;
    },
    member() {
      return this.$store.state.member;
    },
  },
  async mounted() {
    try {
      this.isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1;
    } catch (error) {
      console.error(error);
    }
    if (this.member && this.member.is_block) {
      this.handleCheckBlockUser();
    }

    if (this.edittype == "edit") {
      this.input = {
        departmentStore: this.editdata.department_store,
        branch: this.editdata.branch,
        refNoImage: JSON.parse(this.editdata.ref_no_image),
        refNo: this.editdata.ref_no,
      };
      await this.onChangeDepartment(this.editdata.department_store, true);
      // console.log(this.input);
    }
  },
  methods: {
    getReceiptTemplate() {
      this.receipt_templateloading = true;
      axios
        .get(this.serverUrl + "toacrm/payment-receipt-template", {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
          params: { department_store: this.input.departmentStore },
        })
        .then((response) => {
          this.receipt_templateloading = false;
          if (response.data.responsecode == 200) {
            this.receipt_template = response.data?.data[0]?.image_url;
          }
        });
    },
    async onChangeDepartment(payload, noremovebranch) {
      return new Promise(async (resolve) => {
        if (noremovebranch !== true) {
          this.input.branch = "";
        }
        this.receipt_template = "";
        this.$forceUpdate();
        this.$refs.observer.reset();
        this.getReceiptTemplate();
        var data = await this.$store.dispatch("getSubBranch", payload);
        this.branchOptions = data;
        resolve();
      });
    },
    submitData() {
      return new Promise(async (resolve) => {
        if (await this.$refs.observer.validate()) {
          var data = {
            memberId: this.$store.state.member.memberId,
            refNo: this.input.refNo, // เลขที่ใบเสร็จ

            departmentStore: this.input.departmentStore, // ห้าง
            branch: this.input.branch, // สาขา
            refNoImage: this.input.refNoImage, // รูปใบเสร็จ Array url รูป
            customerName:
              this.$store.state.member.firstName + " " + this.$store.state.member.lastName,
          };
          var method = "post";
          var apiurl = "toacrm/reward-points";
          if (this.edittype == "edit") {
            method = "put";
            apiurl = "toacrm/edit-reward-points";
            data.rewardPointId = this.editdata.id;
          }
          this.saveloading = true;
          axios[method](this.serverUrl + apiurl, data, {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
          }).then(async (response) => {
            this.saveloading = false;

            if (response.data.responsecode == 200) {
              if (response.data.reason) {
                await this.$swal.fire({
                  text: response.data.reason,
                });
              } else {
                this.showCollectSuccess = true;
              }
              this.input = {
                departmentStore: "",
                branch: "",
                refNoImage: [],
                refNo: "",
              };
              this.$refs.observer.reset();
              this.keyupload++;
              // await this.$store.dispatch("sendMessage", "อัปโหลดใบเสร็จสำเร็จ");
              this.$emit("success");
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              if (response.data.responsecode == 400) {
                this.$liff.closeWindow();
              }
            }
            resolve();
          });
        }
      });
    },
    async handleCheckBlockUser() {
      const vm = this;
      const result = await vm.$swal.fire({
        icon: "error",
        html: "คุณไม่สามารถใช้งานเมนูนี้ได้<br/>" + "กรุณาติดต่อเจ้าหน้าที่",
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: "custom-swal",
        confirmButtonText: "ตกลง",
      });
      if (result.value) {
        vm.$emit("isBlockedUser");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
